
import usermanager from "../../usermanager";


export default new class {
  constructor() {

  }
  getAdminCard(complementarySchema) {
    console.log("IsAdmin", usermanager.isAdmin())
    complementarySchema = complementarySchema || []
    return !usermanager.isAdmin() ? null :
    {
    card:"Admin", class:"admin",
      body:[
        {name:"_admin_note", label:"Note admin", type: "textarea", validation: '', size:'large'},
        {name:"_status",     label:"Etat", 			 type: "select", validation: '', options:{draft:'Brouillon', doing : 'En cours', valid : 'Valide', received : 'Réceptionné', done : 'Terminé'} },
        {name:"_visible",    label:"Visible", 	 type: "select", validation: '', options:{visible:'Oui', hidden : 'Non', archived : 'Archivé'} },
        {name:"AKCid",       label:"ID avec AKC", type: "text", validation: '', },
        {name:"AKCsync",     label:"Sync avec AKC", type: "text", validation: '', },
        ...complementarySchema
      ]
    }
  }

  getGetManagerCard() {
    console.log("isManager", (usermanager.isManager()||usermanager.isPartner()))
    return (! (usermanager.isManager() || usermanager.isPartner()) ) ? null :
    {
    card:"Gestion", class:"manager",
      body:[
        {name:"_status",     label:"Etat de ce document",  type: "select", validation: '', options:{doing : 'En cours', valid : 'Valide'} },
        {name:"_admin_note", label:"Note", placeholder:'Ajouter une note si nécessaire', type: "textarea", validation: '', size:'large'},
      ]
    }
  }

}